'use client';

import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';

const measurementId = process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID || 'G-DEDDK6Z5NZ';

export default function GoogleAnalytics() {
  const pathname = usePathname();
  const initialPageViewSent = useRef(false);
  const enabled = process.env.NODE_ENV === 'production';

  useEffect(() => {
    if (!enabled) return;
    if (!initialPageViewSent.current) {
      initialPageViewSent.current = true;
      return;
    }

    const gtag = (window as typeof window & { gtag?: (...args: unknown[]) => void }).gtag;
    gtag?.('config', measurementId, { page_path: pathname });
  }, [enabled, pathname]);

  return null;
}
